module.exports = __webpack_public_path__ + "static/media/event-services-img42.ee20eb03.jpg";